/* Copyright 2026 Element Creations Ltd.
SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial */
import { useEffect, useState, type FC, type JSX } from "react";
import { useLocation } from "react-router-dom";
import {useTranslation} from "react-i18next";
import {RoomAccessNotice} from "../room/RoomAccessNotice";
import { LoadingPage } from "../FullScreenView";
import { useClientLegacy } from "../ClientContext";
import { checkCabinetInvite, confirmedGuestInvite } from "./cabinetInvite";
import { guestRoomLink } from "./guestRoomLink";
export const GuestInviteGate: FC<{ children: JSX.Element }> = ({
  children,
}): JSX.Element => {
  const {t}=useTranslation();
  const [failed,setFailed]=useState(false);
  const location = useLocation(),
    { client, loading, passwordlessUser } = useClientLegacy();
  const key =
    location.key + ":" + (client?.getUserId() ?? "") + ":" + passwordlessUser;
  const [readyFor, setReadyFor] = useState("");
  const ready = readyFor === key;
  useEffect(() => {
    if (loading) return;
    const admin = import.meta.env.VITE_ADMIN_URL;
    if (!admin) {
      setReadyFor(key);
      return;
    }
    const controller = new AbortController();
    const run = async (): Promise<void> => {
      const relative=guestRoomLink(location);
      if(confirmedGuestInvite===relative) {
        if(client && !passwordlessUser && !client.isGuest())setFailed(true);
        else setReadyFor(key);
        return;
      }
      await checkCabinetInvite(relative,admin,controller.signal);
    };
    void run().catch(() => {
      if (!controller.signal.aborted) setFailed(true);
    });
    return () => controller.abort();
  }, [client, loading, passwordlessUser, location, key]);
  return failed ? <RoomAccessNotice title={t("instance.ui.account_verification_failed")} action={<button className="glass-button" onClick={()=>window.location.reload()}>{t("instance.ui.retry_sign_in")}</button>}/> : ready ? children : <LoadingPage />;
};
